import * as types from '../services/DocumentActionType';

function documentReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_DOCUMNETS_REQUEST:
            return { ...state, documentLoading: true };
        case types.GET_DOCUMNETS_SUCCESS:
            return { ...state, documentLoading: false, documents: action.payload };
        case types.GET_DOCUMNETS_FAILURE:
            return { ...state, documentLoading: false };
        default:
            return state;
    }
}
export default documentReducer;